import { Map, List } from 'immutable'
import _get from 'lodash/get'
import _size from 'lodash/size'
import _map from 'lodash/map'
import _filter from 'lodash/filter'
import _compact from 'lodash/compact'
import { map as mapPromise } from 'bluebird'
import { get as getMediaData } from '../media/index'
import { TYPE_CONTENT_SERIES } from '../content-type/index'
import { getFeaturedEpisodeData } from '../user-node-info/index'
import { getAuthIsLoggedIn } from '../auth/index'
import { getPrimary as getPrimaryLanguage } from '../languages/index'
import {
  client as apolloClient,
  APOLLO_CLIENT_ERROR_POLICY_ALL,
  APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
} from '../apollo-graphql/index'
import { GET_CONTENT_POLICY_BATCH } from './query'
import * as actions from './actions'

function getExtraTileData ({ state }) {
  const { auth } = state

  return getAuthIsLoggedIn(auth)
}

/* eslint-disable import/prefer-default-export */
export function watchAppendTilesDataUserInfo ({ after }) {
  return after([
    actions.APPEND_TILES_DATA_USER_INFO,
  ], async ({ dispatch, state, action }) => {
    const { payload } = action
    const { storeKey, userInfo = List() } = payload
    const { tiles, auth, user } = state
    const tileStore = tiles.get(storeKey, Map()) || Map()

    if (!getAuthIsLoggedIn(auth)) {
      return
    }

    if (!userInfo || _size(userInfo) <= 0) {
      return
    }

    dispatch(actions.setTilesUserInfoMediaProcessing(storeKey, true))

    const nodeInfo = _compact(userInfo.map((info) => {
      const id = _get(info, 'id')
      const tile = tileStore.getIn(['data', 'titles'], List()).find((n) => id === n.get('nid')) || Map()

      if (!tile.getIn(['feature', 'id'])) {
        return undefined
      }

      return {
        mediaId: tile.getIn(['feature', 'id']),
        id,
      }
    }))

    if (_size(nodeInfo)) {
      const mediaResponses = await mapPromise(nodeInfo, async (i) => {
        try {
          const data = await getMediaData({ id: _get(i, 'mediaId'), auth, user })
          const media = {
            textTracks: _get(data, 'textTracks', {}) || {},
            mediaLang: _get(data, 'mediaLang', ''),
            byLang: _get(data, 'byLang', {}) || {},
            id: _get(data, 'id', null) || null,
            isForbidden: _get(data, 'isForbidden', false) || false,
          }

          return { id: _get(i, 'id'), media }
        } catch (error) {
          return { id: _get(i, 'id'), error }
        }
      })

      dispatch(actions.appendTilesDataUserInfoMedia(storeKey, mediaResponses))
    }
  }).when(getExtraTileData)
}

export function watchSetTilesData ({ after }) {
  return after([
    actions.SET_TILES_DATA,
    actions.APPEND_TILES_DATA_TITLES,
  ], async ({ dispatch, state, action }) => {
    const { payload } = action
    const { storeKey, data, titles } = payload
    const { auth, user } = state
    const tilesData = _get(data, 'titles') || titles || []
    const filteredTilesData = _filter(tilesData, (n) => {
      return _get(n, 'contentType') === TYPE_CONTENT_SERIES
    })
    const ids = _map(filteredTilesData, (n) => {
      return _get(n, 'id')
    })

    if (!_size(filteredTilesData)) {
      return
    }

    if (!_size(ids)) {
      return
    }

    // Fetching content policy batch to get the allowed subscriptions for the titles
    dispatch(actions.setTilesContentPolicyBatchProcessing(true))
    const contentPolicyBatch = await fetchContentPolicyBatch(auth, user, ids)

    if (_size(contentPolicyBatch)) {
      dispatch(actions.setTilesContentPolicyBatch(storeKey, contentPolicyBatch))
    }

    dispatch(actions.setTilesFeaturedEpisodeProcessing(true))

    const featuredEpisodeData = await getFeaturedEpisodeData(ids, { auth, user })
    const filteredFeaturedEpisodeData = _filter(featuredEpisodeData, (i) => {
      return !_get(i, 'error')
    })

    if (filteredFeaturedEpisodeData) {
      dispatch(actions.appendTilesDataFeaturedEpisode(storeKey, filteredFeaturedEpisodeData))
    }
  }).when(getExtraTileData)
}

/**
 * Fetch content policy batch from GraphQL
 */
async function fetchContentPolicyBatch (auth, user, contentIds) { //
  const authToken = auth.get('jwt')
  const language = getPrimaryLanguage(user.getIn(['data', 'language'], List()))

  try {
    const { data } = await apolloClient.query({
      query: GET_CONTENT_POLICY_BATCH,
      variables: {
        languages: [language, '_primary'],
        contentIds,
      },
      fetchPolicy: APOLLO_CLIENT_FETCH_POLICY_NETWORK_ONLY,
      errorPolicy: APOLLO_CLIENT_ERROR_POLICY_ALL,
      context: {
        jwt: authToken,
      },
    }) || { data: { contentList: { content: [] } } }

    const contentPolicyBatch = _get(data, ['contentList', 'content'], [])
    const formattedContentPolicyBatch = _map(contentPolicyBatch, (content) => {
      return {
        contentId: _get(content, 'contentId'),
        optionIds: _get(content, 'contentPolicy.optionIds'),
      }
    })
    return formattedContentPolicyBatch
  } catch (error) {
    // handle error
    return []
  }
}
